import { useTranslation } from 'react-i18next'

import { DeliverySteps, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const Instructions = ({ steps }) => {
  const { t } = useTranslation()

  if (!steps?.length) return null

  return (
    <Styles.Container>
      <Text type="titleS">{t('Instrucciones')}</Text>
      <DeliverySteps steps={steps} />
    </Styles.Container>
  )
}

export default Instructions
